const save = (key, data) => {
    console.log('save', key, data);
    if (!window.localStorage)
        return;
    window.localStorage.setItem(key, JSON.stringify(data));
};
const load = (key) => {
    if (!window.localStorage)
        return;
    const data = window.localStorage.getItem(key);
    console.log('load', key, data);
    return JSON.parse(data);
};
export default {
    load,
    save,
};
